import { observable, action, computed } from 'mobx';
import axios from '../lib/axios';

//const MAX_NOTIFICATIONS = 25;
class NotificationStore {
  @observable notifications = [];
  loaded = false;

  notificationsCount(category = null, read = 0) {
    if (category)
      return this.notifications.filter(notification => (notification.read == read && notification.category === category)).length;
    else
      return this.notifications.filter(notification => notification.read == read).length;
  }

  @action fetchData() {
    axios.get('/notifications')
      .then((result) => {
        this.loaded = true;
        this.notifications = result.data;
        //if(result.data.length > MAX_NOTIFICATIONS)
        //  this.notifications = result.data.slice(0, MAX_NOTIFICATIONS);
        //else
        //this.notifications = result.data;
      })
      .catch((error) => { });
  }

  @action readNotifications(category) {
    axios.post('/notifications', { category })
      .then((result) => {
        this.fetchData();
      })
      .catch((error) => { });
  }

  @action addNotification(notification) {
    notification.message = decodeURI(notification.message);
    this.notifications.unshift(notification);
  }

  @computed get unreadNotificationsCount() {
    return this.notificationsCount();
  }

  @computed get unreadNoticeNotificationsCount() {
    return this.notificationsCount('notice');
  }

  @computed get unreadQuestionNotificationsCount() {
    return this.notificationsCount('question');
  }

  @computed get unreadContentNotificationsCount() {
    return this.notificationsCount('new_content');
  }

  @computed get unreadContentImportantNotificationsCount() {
    return this.notificationsCount('new_content_important');
  }

  @computed get newContentNotifications() {
    return this.notifications.filter(notification => notification.category === 'new_content').slice(0, 25);
  }

  @computed get newContentImportantNotifications() {
    return this.notifications.filter(notification => notification.category === 'new_content_important').slice(0, 25);
  }
}

export default new NotificationStore();



// WEBPACK FOOTER //
// ./src/stores/NotificationStore.js